import React from "react";
import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  ContractButton,
  ContentWrapper
} from "./styles";
import backgroundImage from "./assets/PopupG.png";
import { LINKS } from "@constants";

const ModalSeguro = ({ isOpen, onClose, onContractClick, onModalClosed }) => {
  if (!isOpen) return null;

  function handleModalClick(e) {
    e.stopPropagation();
  }

  function handleClose() {
    onClose();

    if (onModalClosed) {
      onModalClosed();
    }
  }

  function handleContractClick() {
    window.open(LINKS.amparoConfortoPopupMaior, "_blank");

    if (onContractClick) {
      onContractClick();
    }

    handleClose();
  }

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContent
        onClick={handleModalClick}
        backgroundImage={backgroundImage}
      >
        <CloseButton onClick={handleClose}>&times;</CloseButton>
        <ContentWrapper />
        <ContractButton onClick={handleContractClick}>
          SAIBA MAIS
        </ContractButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ModalSeguro;
